/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MemberManagementListOrderRequest = {
    memberId: number;
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: MemberManagementListOrderRequest.direction | null;
    types?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    orderCode?: string | null;
};

export namespace MemberManagementListOrderRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

